import React, { useState } from 'react';
import {
  StyledTypographyTitle, 
  StyledAvatar,
  StyledRow,
  StyledTypographyHeader,
  StyledGridContainer,
  StyledTypographyContent,
  StyledCol,
} from './InformationNewJoiner.style';
import Typography from "component/commonComponents/Typography";
import { Box } from '@mui/material';
import { Grid, Divider, Tooltip, IconButton, Snackbar } from '@mui/material';
import { ClampText } from './ClampText';
import AvatarDefault from '../../../assets/images/no_avatar.jpg';
import useBreakpoint, { Breakpoint } from 'utils/useBreakpoint';
import { MailIcon } from 'component/commonComponents/Icon';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { StyledIcon } from "component/commonComponents/Icon/icon.style";
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from "../../theme/defaultTheme";
import CalendarAndCountDown from '../CalendarAndCountDown';
import { getAvatarName } from 'utils/functions';

const InformationNewJoiner = (props:any) => {
  const {userInfor, locale} = props; 
  const theme = useTheme() as typeof DefaultUptimeTheme;
  const newJoinerName = !!userInfor?.first_name && !!userInfor?.last_name? `${userInfor?.first_name} ${userInfor?.last_name}` : '';
  const maxLength = 51;
  const breakpoint = useBreakpoint();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const onClickCopy = () => {
    const copyText = userInfor?.email?.toString();
    navigator.clipboard.writeText(copyText);
    setOpenSnackbar(prev => !prev);
  };

  const urlGmapLocation = "https://www.google.com/maps/search/" + (!!userInfor?.manager?.['location.name'] ? userInfor?.manager['location.name'] : '');

  return (
    <StyledGridContainer container>
        <Grid item xs={12} lg={3}>
          <Grid container alignItems="center" flexDirection="column">
            <Grid item xs={12} lg={12} marginTop="12px">
              <StyledAvatar 
                className="avatar-new-joiner" 
                src={userInfor?.avatar} 
                alt={''} 
              >
                {getAvatarName(newJoinerName)}
              </StyledAvatar>
            </Grid>
            <Grid item xs={12} lg={12} marginTop="12px">
              <Typography height="100%" minHeight='45px' fontSize="20px" fontWeight={600} textAlign="center">
                <ClampText maxLineCount={2}>
                  {newJoinerName}
                </ClampText>
              </Typography>            
            </Grid>
            <Grid item xs={12} lg={12}>
              <Typography height="100%" minHeight='26px' fontSize="16px" fontWeight={400}>{!!userInfor?.job_title? userInfor?.job_title : '' }</Typography>              
            </Grid>
            <Grid item xs={12} lg={12} marginTop="12px">
              <Tooltip title={userInfor?.email}  arrow>
                  <IconButton
                    size="small"                
                    onClick={() => onClickCopy()}
                    aria-label="Copy Button"
                  >
                    <MailIcon/>
                  </IconButton>        
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>      
        <Grid item xs={12} lg={6} className="grid-manager-info">    
          <Divider orientation={breakpoint >= Breakpoint.lg? "vertical" : "horizontal"} variant="inset" sx={breakpoint >= Breakpoint.lg? { ml: '12px', mt: '40px', mb: '8px', height: '80%' } : {ml: '12px', mt: '12px', mb: '12px'}}/>          
          <StyledCol>
            <StyledRow className='header-report-manager'>
              <Typography color="rgba(0, 0, 0, 0.70)" height="45px" fontSize="16px" fontWeight={600}>{locale?.reportManagerHeader}</Typography>              
            </StyledRow>
            <Box sx={{ display:"flex", alignItems:"center" }}>
              <Box sx={{ minWidth:"125px", display:"flex", flexDirection:"row-reverse", paddingRight:"12px" }}>
                <StyledAvatar 
                  src={!!userInfor?.manager?.azure_photo? userInfor?.manager?.azure_photo : AvatarDefault} 
                  alt={''} 
                >
                  {getAvatarName(userInfor?.manager?.name)}
                </StyledAvatar>
              </Box>
              <ClampText maxLineCount={2}>
                <StyledTypographyHeader>{userInfor?.manager?.name}</StyledTypographyHeader>
              </ClampText>
            </Box>
            <StyledRow>
              <StyledTypographyTitle>{locale?.workEmail}</StyledTypographyTitle>
              <Tooltip title={userInfor?.manager?.email?.length > maxLength? userInfor?.manager?.email : ''} arrow>
                <StyledTypographyContent>
                  <ClampText maxLineCount={2}>{!!userInfor?.manager?.email? userInfor?.manager?.email : 'N/A'}</ClampText>
                </StyledTypographyContent>
              </Tooltip>
            </StyledRow>
            <StyledRow>
              <StyledTypographyTitle>{locale?.jobTitle}</StyledTypographyTitle>
              <Tooltip title={userInfor?.manager?.title?.length > maxLength? userInfor?.manager?.title : ''} arrow>
                <StyledTypographyContent>
                  <ClampText maxLineCount={2}>
                    {!!userInfor?.manager?.title? userInfor?.manager?.title : 'N/A' }
                  </ClampText>
                </StyledTypographyContent>
              </Tooltip>
            </StyledRow>
            <StyledRow>
              <StyledTypographyTitle>{locale?.department}</StyledTypographyTitle>
              <Tooltip title={userInfor?.manager?.['department.name']?.length > maxLength? userInfor?.manager['department.name'] : ''} arrow>
                <StyledTypographyContent>
                  <ClampText maxLineCount={2}>
                    {!!userInfor?.manager?.['department.name']? userInfor?.manager['department.name'] : 'N/A'}
                  </ClampText>
                </StyledTypographyContent>
              </Tooltip>
            </StyledRow>
            <StyledRow>
              <StyledTypographyTitle>{locale?.workPhone}</StyledTypographyTitle>
              <StyledTypographyContent>
                <ClampText maxLineCount={2}>
                  {!!userInfor?.manager?.mobile_phone? userInfor?.manager?.mobile_phone : 'N/A'}
                </ClampText>
              </StyledTypographyContent>
            </StyledRow>
            <StyledRow>
              <StyledTypographyTitle>{locale?.officeLocation}</StyledTypographyTitle>
              <Tooltip title={locale?.clickToOpenGmaps} arrow>
                <IconButton  
                  onClick={() => window.open(urlGmapLocation, '_blank')}
                  size="small"
                  aria-label="Location button"
                >
                  <StyledIcon
                    styleIcon={{color: `${theme.uptimeColors.mainTheme.primary}`, fontSize: '20', width: '100%'}}
                  >
                    <LocationOnIcon/>
                  </StyledIcon>
                </IconButton>            
              </Tooltip>
              <Tooltip title={userInfor?.manager?.['location.name']?.length > maxLength ? userInfor?.manager['location.name'] : ''} arrow>
                <StyledTypographyContent>
                  <ClampText maxLineCount={2}>
                    {!!userInfor?.manager?.['location.name'] ? userInfor?.manager['location.name'] : 'N/A'}
                  </ClampText>
                </StyledTypographyContent>
              </Tooltip>
            </StyledRow>             
          </StyledCol>              
          <Divider orientation={breakpoint >= Breakpoint.lg? "vertical" : "horizontal"} variant="middle" sx={{ mt: `${breakpoint >= Breakpoint.lg? '40px':'12px'}`, mb: '12px', mr: '18px', height: `${breakpoint >= Breakpoint.lg? '80%':'0'}`}}/>            
        </Grid>       
        <Grid item xs={12} lg={3}>
          <CalendarAndCountDown userInfor={userInfor} locale={locale}/>
        </Grid>
        <Snackbar 
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={openSnackbar} 
          autoHideDuration={3000}
          message={locale?.copiedEmail}
          onClose={() => setOpenSnackbar(false)}
        />
    </StyledGridContainer>
  );
};
export default InformationNewJoiner;
